module.exports = __webpack_public_path__ + "img/delivery-truck.ddf18753.svg";